import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Heading from "../../Components/Heading/Heading";
import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm from "../../Components/InputForm/InputForm";
import "./TicketAssignment.css";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { APICall } from "../../Helpers/API/APICalls";
import {
  getAutoPopulatedDataForTicket,
  getCapacityAllocationDataByEngagement,
  GetDropDownList,
  getEngagementMasterDataById,
  InsertUpdateTicketData,
  TimesheetTotalHours,
  insertTicketHistory,
  getTicketDataById,
  checkForEngagementLead,
  getTicketData,

} from "../../Helpers/API/APIEndPoints";
import uuid from "react-uuid";
import moment from "moment";
import {
  notChargableResonsOptions,
  priorityOptions,
  TicketStatus,
  TicketType,
} from "../../Common/CommonJson";
import { useLocation, useNavigate } from "react-router-dom";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import notify from "../../Helpers/ToastNotification";
//yp
import { APICalls } from "../../Helpers/API/APICalls2";
import axios from "axios";
import fileDownload from "js-file-download";

const TicketAssignment = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const { EmployeeId, RoleId } = getContext();
  const [Engagement, setEngagement] = useState<any>({});
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [assignedToOptions, setAssignedToOptions] = useState<any>([]);
  const [fromDate, setFromDate] = React.useState<any>(
    moment().startOf("month").toDate()
  );
  const [toDate, setToDate] = React.useState<any>(
    moment().endOf("month").toDate()
  );
  const [disabled, setDisabled] = useState(false);
  const [ticket, setTicket] = useState<any>("");
  const [ticketTitle, setTicketTitle] = useState<any>("");
  const [Description, setDescription] = useState<any>("");
  const [AssignedTo, setAssignedTo] = useState<any>({});
  const [Startbydate, setStartbydate] = React.useState<Date | null>(new Date());
  const [Completebydate, setCompletebydate] = React.useState<Date | null>(
    new Date()
  );
  const [PlannedHours, setPlannedHours] = useState<any>("");
  const [isChargable, setisChargable] = useState<any>(true);
  const [Reason, setReason] = useState<any>({});
  const [allocatedMandays, setAllocatedMandays] = useState<any>("");
  const [assignedMandays, setAssignedMandays] = useState<any>("");
  const [balancedMandays, setBalancedMandays] = useState<any>("");
  const [priority, setPriority] = useState<any>({});
  const [incidentDate, setIncidentDate] = React.useState<Date | null>(
    new Date()
  );
  const [reportedDate, setReportedDate] = React.useState<Date | null>(
    new Date()
  );
  const [prevTicket, setPrevTicket] = useState<any>("");
  const [prevTicketId, setPrevTicketId] = useState<any>("");
  const [isAdhoc, setIsAdHoc] = useState<boolean>(false);
  const [type, setType] = useState<any>(false);
  const [formErrors, setFormErrors] = useState<any>({});
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [ReasonOptions, setReasonOptions] = useState<any>([]);
  const [budgetMandaysPerMonth, setBudgetMandaysPerMonth] = useState<any>("");
  const [totalTimesheetHours, setTotalTimesheetHours] = useState<any>("");
  const [dropDown1, setDropDown1] = useState(false);
  const [assignedToOptionsLoaded, setAssignedToOptionsLoaded] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isEngagementLead, setIsEngagementLead] = useState(false); //Prashant
  const [ticketsharepointLinkId, setTicketsharepointLinkId] = useState(0); //yp
  let formErrorObj = {};

  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );

  const EditId = (location.state as { id: number })?.id;

  //added by yogesh
  // //const [FileName, setFileName] = useState<any>("No File Uploaded");
  // const [fileName, setFileName] = useState<string>("No File Uploaded");
  // //const [POFile, setPOFile] = useState<any>();
  // const [POFile, setPOFile] =useState<File[]>([]);
  // const [errorMsg, setErrorMsg] = useState("");



  // const handleFiles = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   apiFieldName: string
  // ) => {
  //   const file = e.target.files?.[0];

  //   if (!file) {
  //     setFormErrors((prevState) => ({
  //       ...prevState,
  //       ["poFile_isEmpty"]: "Please upload PO",
  //     }));
  //     return;
  //   } else {
  //     setFormErrors((prevState) => ({
  //       ...prevState,
  //       ["poFile_isEmpty"]: undefined,
  //     }));
  //   }


  //   const allowedTypes = new Set([
  //     "application/pdf", // PDF
  //     "application/msword", // DOC
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  //     "image/png", // PNG
  //     "image/jpeg", // JPEG, JPG
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  //     "application/vnd.ms-powerpoint", // PPT
  //     "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX
  //     "message/rfc822", // EML
  //   ]);

  //   if (allowedTypes.has(file.type)) {
  //     setFileName(file.name);
  //     //setPOFile(file);
  //     setPOFile((prevFiles) => [...prevFiles, file]);  // Add the new file to the array

  //     setErrorMsg("");
  //   } else {
  //     notify(
  //       1,
  //       "The selected file is not allowed. Please upload a valid file."
  //     );
  //     setErrorMsg(
  //       "The selected file is not allowed. Please upload a valid file."
  //     );
  //     setFileName("");
  //     //setPOFile(null);
  //     setPOFile([]); 
  //   }


  // };


  const [FileNames, setFileNames] = useState<string[]>([]);

  const [files, setFiles] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [tickedId, setticketId] = useState(0);

  //console.log(FileNames);
  //console.log(files);

  

  const handleClear = () => {
    setFileNames([]); 
    setFiles([]); 
  };

  const handleFiles = (
    e: React.ChangeEvent<HTMLInputElement>,
    apiFieldName: string
  ) => {
    const selectedFiles = e.target.files;

    if (!selectedFiles || selectedFiles.length === 0) {
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: "Please upload PO",
      }));

      return;
    } else {
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: undefined,
      }));
    }

    // Allowed file types
    const allowedTypes = new Set([
      "application/pdf", // PDF
      "application/msword", // DOC
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "image/png", // PNG
      "image/jpeg", // JPEG, JPG
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-powerpoint", // PPT
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX
      "message/rfc822", // EML
    ]);

    const validFiles: File[] = [];
    const invalidFiles: File[] = [];

    // Separate valid and invalid files
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      if (allowedTypes.has(file.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file);
      }
    }

 
    if (validFiles.length > 0) {
    

      setFileNames([`${validFiles.length} files selected`]);
    
      setFiles(validFiles);

      setErrorMsg("");
    }

    if (validFiles.length > 5) {
      notify(1, "At Max five Files are allowed")
    }

    // Handle invalid files
    if (invalidFiles.length > 0) {
      notify(
        1,
        "The selected files are not allowed. Please upload valid files."
      );
      setErrorMsg(
        "The selected files are not allowed. Please upload valid files."
      );
    }
  };

  //Ended by yp

  //Prashant
  const checkEngagementLead = async () => {

    let obj = {
      CreatedBy: EmployeeId,
      EngagementId: Engagement.engagementId,
    }


    const { data } = await APICall(checkForEngagementLead, "POST", obj);

    if (data != null || data != undefined) {
      setIsEngagementLead(data[0].isEngagementLead);
    }


  }

  useEffect(() => {
    (async () => {
      await checkEngagementLead();
    })()

  }, [Engagement])



  //Omkar P
  useEffect(() => {
    if (dropDown1) {
      fetchData();
    }
  }, [
    EngagementOptions,
    assignedToOptions,
    assignedToOptionsLoaded,
    ReasonOptions,
  ]);



  //fetch data when we click edit button from ManagerDashboard.tsx file
  // const fetchData = async () => {
  //   debugger;
  //   showLoader();
  //   try {
  //     if (location === null || location.state === null || EditId === null) {
  //       console.error("There is no record for fetch.");
  //       hideLoader();
  //       return;
  //     }
  //     const post = {
  //       id: EditId,
  //     };
  //     const { data } = await APICall(
  // ById, "POST", post);
  //     if (data !== null && typeof data !== "string") {
  //       //set the values in field
  //       const EngId = data.engagementId;
  //       const foundEngagement = EngagementOptions.find(
  //         (item) => item.engagementId === EngId
  //       );
  //       if (foundEngagement) {
  //         setEngagement(foundEngagement);
  //       } else {
  //         console.error(
  //           `Check this ${EngId} not found in Engagement dropdown.`
  //         );
  //       }

  //       //Assign to
  //       const assignId = data.assignedTo;
  //       let assignedToArray = [];
  //       if (!assignedToOptionsLoaded) {
  //         assignedToArray = await assignedToApiCall(EngId);
  //       }

  //       // Now you can use assignedToArray
  //       const foundAssign = assignedToArray.find(
  //         (item) => item.value == assignId
  //       );

  //       if (foundAssign) {
  //         setAssignedTo(foundAssign);
  //       } else {
  //         console.error(
  //           `Check this ${assignId} not found in assignedToOptions.`
  //         );
  //       }

  //       setTicketTitle(data.ticketTitle);
  //       setDescription(data.ticketDescription);
  //       setReportedDate(data.reportDate);
  //       setIncidentDate(data.incidentDate);

  //       // Check if resolve Date is not null
  //       if (data.resolveDate !== null) {
  //         setCompletebydate(data.resolveDate);
  //       }

  //       // Check if start Date is not null
  //       if (data.startDate !== null) {
  //         setStartbydate(data.startDate);
  //       }

  //       setPlannedHours(data.hoursAssigned);

  //       const PriId = data.priority;
  //       const PriOp = priorityOptions.find((item) => item.value === PriId);
  //       setPriority(PriOp);
  //       setisChargable(data.isChargeable);
  //       const reasonId = data.noChargesReason;
  //       const foundreson = ReasonOptions.find(
  //         (item) => item.noChargesReason === reasonId
  //       );
  //       if (foundreson) {
  //         setReason(data.noChargesReason);
  //       } else {
  //         console.error(
  //           `Check this ${reasonId} not found in Engagement dropdown.`
  //         );
  //       }
  //       // Other fields (hoursSpent, assignedTo, responedDate, ticketStatus) can be handled here

  //       setDropDown1(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  const fetchData = async () => {
    let tempArray = [];

    try {
      if (location === null || location.state === null || EditId === null) {
        console.error("There is no record for fetch.");
        hideLoader();
        return;
      }

      const post = {
        id: EditId, // Using EditId here
      };

      //const { data } = await APICall(getTicketDataById, "POST", post);
      let { data } = await APICall(getTicketData, "POST", post); //change by yogesh
     // console.log(data);

      if (data !== null && typeof data !== "string") {
        const EngId = data.engagementId;

        const foundEngagement = EngagementOptions.find(
          (item) => item.engagementId === EngId
        );

        if (foundEngagement) {
          setEngagement(foundEngagement);
        } else {
          console.error(
            `Check this ${EngId} not found in Engagement dropdown.`
          );
        }

        // Assign to
        const assignId = data.assignedTo;
        let assignedToArray = [];

        if (!assignedToOptionsLoaded) {
          assignedToArray = await assignedToApiCall(EngId);
        }

        // Now you can use assignedToArray
        const foundAssign = assignedToOptions.find(
          (item) => item.value == assignId
        );

        if (foundAssign) {
          setAssignedTo(foundAssign);
        } else {
          console.error(
            `Check this ${assignId} not found in assignedToOptions.`
          );
        }

        setTicketTitle(data.ticketTitle);
        setDescription(data.ticketDescription);
        setReportedDate(data.reportDate);
        setIncidentDate(data.incidentDate);
        setTicketsharepointLinkId(data.ticketSharePointLinkId);
        //console.log(data.ticketSharePointLinkId);

        // Check if resolve Date is not null
        if (data.resolveDate !== null) {
          setCompletebydate(data.resolveDate);
        }

        // Check if start Date is not null
        if (data.startDate !== null) {
          setStartbydate(data.startDate);
        }

        setPlannedHours(data.hoursAssigned);

        const PriId = data.priority;
        const PriOp = priorityOptions.find((item) => item.value === PriId);
        setPriority(PriOp);
        setisChargable(data.isChargeable);

        const reason = await CommonDropdownFunction(
          "reason",
          foundEngagement.engagementType, // Assuming engagementType is the key
          true
        );

        if (reason != undefined || reason != null) {
          tempArray = reason.map((reasons) => ({
            value: reasons.id,
            label: reasons.reason,
          }));
          setReasonOptions(tempArray);

          // Compare foundEngagement.engagementType with reasonId and set Reason accordingly
          const reasonId = data.noChargesReason;
          const foundReason = tempArray.find((item) => item.label == reasonId);

          if (foundReason) {
            setReason(foundReason);
          } else {
            console.error(
              `Check this ${reasonId} not found in Reason options.`
            );
          }
        }
        await getBudgetMandays(EngId, foundEngagement.engagementType);
        await getTotalTimesheetHours(EngId);
        // Other fields (hoursSpent, assignedTo, responedDate, ticketStatus) can be handled here
        setIsActive(data.isActive);
        setDropDown1(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      hideLoader();
    }
  };


  //Omkar P

  const getBudgetMandays = async (id, type) => {
    const eType =
      type === 1
        ? "AMC"
        : type === 2
          ? " PRODUCT"
          : type === 3
            ? "PROJECT"
            : type === 4
              ? "T&M"
              : "INTERNAL";

    let post = {
      EngagementId: id,
      EngagementType: eType,
    };
    const { data } = await APICall(
      getCapacityAllocationDataByEngagement,
      "POST",
      post
    );

    if (data && data.budgetMandaysPerMonth !== null) {
      setBudgetMandaysPerMonth(data.budgetMandaysPerMonth);
    } else {
      setBudgetMandaysPerMonth("0");
    }
  };

  const getTotalTimesheetHours = async (id) => {
    let obj = {
      EngagementId: "1",
      FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
    };
    const { data } = await APICall(TimesheetTotalHours, "POST", obj);
    if (data) {
      setTotalTimesheetHours(data[0].totalHours);
    }
  };

  const getAutoPopulateData = async () => {
    showLoader();
    if (
      Engagement.engagementId !== null &&
      fromDate !== null &&
      toDate !== null
    ) {
      var postObj = {
        EngagementId: Engagement.engagementId,
        fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
      };

      var autoPopulateData = await APICall(
        getAutoPopulatedDataForTicket,
        "POST",
        postObj
      );

      if (autoPopulateData.data != undefined || autoPopulateData.data != null) {
        setFormErrors({
          ...formErrors,
          ["fromDate_isEmpty"]: "",
        });

        setFormErrors({
          ...formErrors,
          ["toDate_isEmpty"]: "",
        });

        if (autoPopulateData.data.mandays == null) {
          autoPopulateData.data.mandays = 0;
        }
        setAllocatedMandays(autoPopulateData.data.mandays);
        setAssignedMandays(
          (autoPopulateData.data.hoursAssigned / 8.5).toFixed(2)
        );
        setBalancedMandays(
          (
            autoPopulateData.data.mandays -
            autoPopulateData.data.hoursAssigned / 8.5
          ).toFixed(2)
        );
      } else {
        //  setFromDate(null);
        // setToDate(null);
        setAllocatedMandays("");
        setAssignedMandays("");
        setBalancedMandays("");
      }
    }
    hideLoader();
    // else {
    //   if (fromDate == undefined || fromDate == null || fromDate == "") {
    //     await setFormErrors({
    //       ...formErrors,
    //       ["fromDate_isEmpty"]: "from date cannot be empty",
    //     });
    //   }
    //   if (toDate == undefined || toDate == null || toDate == "") {
    //     await setFormErrors({
    //       ...formErrors,
    //       ["toDate_isEmpty"]: "To date cannot be empty",
    //     });
    //   }
    // }
  };

  useEffect(() => {
    getAutoPopulateData();
  }, [fromDate, toDate, Engagement]);

  // useEffect(() => {
  //   getAutoPopulateData();
  // }, [toDate]);

  const checkValidations = async () => {
    var objError = {};
    if (!Engagement || Object.keys(Engagement).length === 0) {
      formErrorObj["Engagement_isEmpty"] = "Engagement can not be empty";
    }
    if (!isAdhoc) {
      if (fromDate == undefined || fromDate == null) {
        objError["fromDate_isEmpty"] = "From date cannot be empty";
      }
      if (toDate == undefined || toDate == null) {
        objError["toDate_isEmpty"] = "To date cannot be empty";
      }
      if (!assignedMandays || assignedMandays === "") {
        formErrorObj["assignedMandays_isEmpty"] =
          "Assigned Mandays can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(assignedMandays)) {
        formErrorObj["assignedMandays_isEmpty"] =
          "Assigned Mandays should have maximum 2 decimals only";
      }
      if (!allocatedMandays || allocatedMandays === "") {
        formErrorObj["allocatedMandays_isEmpty"] =
          "Allocated Mandays can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(allocatedMandays)) {
        formErrorObj["allocatedMandays_isEmpty"] =
          "Allocated Mandays should have maximum 2 decimals only";
      }
      if (
        !balancedMandays ||
        balancedMandays === "" ||
        balancedMandays === undefined
      ) {
        formErrorObj["balancedMandays_isEmpty"] =
          "Balance Mandays can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(balancedMandays)) {
        formErrorObj["balancedMandays_isEmpty"] =
          "Balance Mandays should have maximum 2 decimals only";
      }
      if (
        AssignedTo.value == undefined ||
        AssignedTo.value == null ||
        AssignedTo.value == ""
      ) {
        objError["AssignedTo_isEmpty"] = "Assigned to cannot be empty";
      }
    }
    if (
      Engagement.engagementId == undefined ||
      Engagement.engagementId == null ||
      Engagement.engagementId === ""
    ) {
      objError["Engagement_isEmpty"] = "Engagement cannot be empty";
    }
    if (
      ticketTitle == undefined ||
      ticketTitle == null ||
      ticketTitle.trim() === ""
    ) {
      objError["ticketTitle_isEmpty"] = "Ticket title to cannot be empty";
    }
    if (
      ticketTitle == undefined ||
      ticketTitle == null ||
      ticketTitle.trim() === ""
    ) {
      objError["ticketTitle_isEmpty"] = "Ticket title to cannot be empty";
    }
    if (
      Description == undefined ||
      Description == null ||
      Description.trim() === ""
    ) {
      objError["Description_isEmpty"] = "Ticket Description to cannot be empty";
    }
    if (Description == undefined || Description == null || Description == "") {
      objError["Allocated_isEmpty"] = "Description cannot be empty";
    }
    if (Startbydate == undefined || Startbydate == null) {
      objError["Startbydate_isEmpty"] = "Start by date cannot be empty";
    }
    if (Completebydate == undefined || Completebydate == null) {
      objError["Completebydate_isEmpty"] = "Resolved by date cannot be empty";
    }
    if (incidentDate == undefined || incidentDate == null) {
      objError["incidentDate_isEmpty"] = "Incident date cannot be empty";
    }
    if (reportedDate == undefined || reportedDate == null) {
      objError["reportedDate_isEmpty"] = "Reported date cannot be empty";
    }
    if (
      PlannedHours == undefined ||
      PlannedHours == null ||
      PlannedHours == "" ||
      isNaN(PlannedHours) ||
      PlannedHours <= 0
    ) {
      objError["PlannedHours_isEmpty"] = "Planned Hours cannot be empty";
    }
    if (isChargable === false) {
      if (
        Reason.value == undefined ||
        Reason.value == null ||
        Reason.value == ""
      ) {
        objError["Reason_isEmpty"] = "Reason cannot be empty";
      }
    }
    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "fromDate") {
      setFromDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: undefined,
        }));
        formErrorObj["fromDate_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: "From date can not be empty",
        }));
        formErrorObj["fromDate_isEmpty"] = "From date can not be empty";
      }
    }
    if (apiFieldName === "toDate") {
      setToDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: undefined,
        }));
        formErrorObj["toDate_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: "To date can not be empty",
        }));
        formErrorObj["toDate_isEmpty"] = "To date can not be empty";
      }
    }
    if (apiFieldName === "incidentDate") {
      setIncidentDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["incidentDate_isEmpty"]: undefined,
        }));
        formErrorObj["incidentDate_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["incidentDate_isEmpty"]: "Incident date can not be empty",
        }));
        formErrorObj["incidentDate_isEmpty"] = "Incident date can not be empty";
      }
    }
    if (apiFieldName === "reportedDate") {
      setReportedDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["reportedDate_isEmpty"]: undefined,
        }));
        formErrorObj["reportedDate_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["reportedDate_isEmpty"]: "Reported date can not be empty",
        }));
        formErrorObj["reportedDate_isEmpty"] = "Reported date can not be empty";
      }
    }
    if (apiFieldName === "ticket") {
      setTicket(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticket_isEmpty"]: undefined,
        }));
        formErrorObj["ticket_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticket_isEmpty"]: "Ticket can not be empty",
        }));
        formErrorObj["ticket_isEmpty"] = "Ticket can not be empty";
      }
    }
    if (apiFieldName === "prevTicket") {
      setPrevTicket(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["prevTicket_isEmpty"]: undefined,
        }));
        formErrorObj["prevTicket_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["prevTicket_isEmpty"]: "Previous ticket can not be empty",
        }));
        formErrorObj["prevTicket_isEmpty"] = "Previous ticket can not be empty";
      }
    }
    if (apiFieldName === "prevTicketId") {
      setPrevTicketId(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["prevTicketId_isEmpty"]: undefined,
        }));
        formErrorObj["prevTicketId_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["prevTicketId_isEmpty"]: "Previous ticket id can not be empty",
        }));
        formErrorObj["prevTicketId_isEmpty"] =
          "Previous ticket id can not be empty";
      }
    }
    if (apiFieldName === "ticketTitle") {
      setTicketTitle(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticketTitle_isEmpty"]: undefined,
        }));
        formErrorObj["ticketTitle_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticketTitle_isEmpty"]: "Ticket title can not be empty",
        }));
        formErrorObj["ticketTitle_isEmpty"] = "Ticket title can not be empty";
      }
    }
    if (apiFieldName === "Description") {
      setDescription(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Description_isEmpty"]: undefined,
        }));
        formErrorObj["Description_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Description_isEmpty"]: "Description can not be empty",
        }));
        formErrorObj["Description_isEmpty"] = "Description can not be empty";
      }
    }
    if (apiFieldName === "PlannedHours") {
      setPlannedHours(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["PlannedHours_isEmpty"]: undefined,
        }));
        formErrorObj["PlannedHours_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["PlannedHours_isEmpty"]: "Planned hours can not be empty",
        }));
        formErrorObj["PlannedHours_isEmpty"] = "Planned hours can not be empty";
      }
    }
    if (apiFieldName === "Startbydate") {
      setStartbydate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["Startbydate_isEmpty"]: undefined,
        }));
        formErrorObj["Startbydate_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["Startbydate_isEmpty"]: "Start by date can not be empty",
        }));
        formErrorObj["Startbydate_isEmpty"] = "Start by date can not be empty";
      }
    }
    if (apiFieldName === "Completebydate") {
      setCompletebydate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["Completebydate_isEmpty"]: undefined,
        }));
        formErrorObj["Completebydate_isEmpty"] = undefined;
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["Completebydate_isEmpty"]: "Resolved by date can not be empty",
        }));
        formErrorObj["Completebydate_isEmpty"] =
          "Resolved by date can not be empty";
      }
    }
    if (apiFieldName === "allocatedMandays") {
      setAllocatedMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["allocatedMandays_isEmpty"]: undefined,
        }));
        formErrorObj["allocatedMandays_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["allocatedMandays_isEmpty"]: "Allocated mandays can not be empty",
        }));
        formErrorObj["allocatedMandays_isEmpty"] =
          "Allocated mandays can not be empty";
      }
    }
    if (apiFieldName === "assignedMandays") {
      setAssignedMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["assignedMandays_isEmpty"]: undefined,
        }));
        formErrorObj["assignedMandays_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["assignedMandays_isEmpty"]: "Assigned mandays can not be empty",
        }));
        formErrorObj["assignedMandays_isEmpty"] =
          "Assigned mandays can not be empty";
      }
    }
    if (apiFieldName === "balancedMandays") {
      setBalancedMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["balancedMandays_isEmpty"]: undefined,
        }));
        formErrorObj["balancedMandays_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["balancedMandays_isEmpty"]: "balanced Mandays can not be empty",
        }));
        formErrorObj["balancedMandays_isEmpty"] =
          "Balanced mandays can not be empty";
      }
    }
  };

  const handleCheckEvent = async (checkedValue, apiFieldName) => {
    if (apiFieldName === "isChargable") {
      setFormErrors((preState) => ({
        ...preState,
        ["Reason_isEmpty"]: undefined,
      }));
      formErrorObj["Reason_isEmpty"] = undefined;
      setReason({});
      setisChargable(checkedValue);
    }
    if (apiFieldName === "type") {
      setType(checkedValue);
    }
  };

  const getCapacityEngagementByIdApiCall = async (engagementId: any) => {
    if (engagementId !== 0) {
      let post = {
        id: engagementId,
      };
      const { data } = await APICall(getEngagementMasterDataById, "POST", post);
      if (data !== null || typeof data !== "string") {
        {
          //     "id": 2,
          //     "engagement": "New Engagement",
          //     "engagementType": 1,
          //     "pomonths": 12,
          //     "pomanDaysPerMonth": 123,
          //     "budgetMandaysPerMonth": 456,
          //     "spentMandates": 123,
          //     "balanceMandays": 123,
          //     "pomanDays": null,
          //     "budgetMandays": null,

          // setAllocatedMandays()
          // setAssignedMandays()
          setBalancedMandays(data.balanceMandays);

          // setPoMandaysPerMonth(data.pomanDaysPerMonth)
          // setBudgetMandaysPerMonth(data.budgetMandaysPerMonth)
          // setAllocatedMandaysPerMonth(data.allocatedMandaysPerMonth)
          // setSpentMandays(data.spentMandates)
          // setBalanceMandays(data.balanceMandays)
          // setPoMandays(data.pomanDays)
          // setBudgetMandays(data.budgetMandays)
        }
      }
    }
  };

  const onClickFunction = async (action) => {
    if (action === "submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty) {
        setDisabled(true);
        let requestObject = {
          Id: EditId, //addtional id here
          TaskUid: uuid(),
          TaskTitle: "", //
          EngagementId: Engagement.engagementId,
          TicketTitle: ticketTitle,
          PhaseId: parseInt(Engagement.phasevalue),
          ApplicationId: parseInt(Engagement.applicationValue),
          TicketDescription: Description,
          AssignedTo: isAdhoc ? context.EmployeeId : AssignedTo.value, //7 //AssignedTo.value,
          Priority: priority.value,
          TicketNatureOfIssue: priority.value,
          HoursAssigned: Number(PlannedHours).toFixed(2),
          IncidentDate: moment(incidentDate).format(moment.HTML5_FMT.DATE), //split T
          ReportDate: moment(reportedDate).format(moment.HTML5_FMT.DATE), //split T
          StartDate: moment(Startbydate).format(moment.HTML5_FMT.DATE), //split T
          ResolveDate: moment(Completebydate).format(moment.HTML5_FMT.DATE), //split T
          TicketType: type == true ? TicketType.repeated : TicketType.new,
          TicketStatus: TicketStatus.NotStarted, //
          IsChargeable: isChargable,
          NoChargesReason: Reason.label,
          IsActive: isActive,
          CreatedDate: moment(new Date()).format(),
          CreatedBy: context.EmployeeId, //
        };

        //add by yogesh formdata

        let formData2 = new FormData();
        formData2.append("TaskUid", uuid());
        //console.log("EditId:", EditId);
        const idValue = EditId ?? 0;
       // console.log("Submitting Ticket ID:", idValue);

        formData2.append("Id", idValue.toString());

        formData2.append("TicketTitle", ticketTitle);
       // formData2.append("EngagementId", Engagement.engagementId.toString());
        formData2.append("EngagementId", Engagement.engagementId?  Engagement.engagementId.toString(): "0");

        // if (Engagement.phasevalue !== undefined && Engagement.phasevalue !== null) {
        //   formData2.append("PhaseId", Engagement.phasevalue.toString());
        // } else {
        //   formData2.append("PhaseId", "");
        // }
        formData2.append("PhaseId",  Engagement.phasevalue ? Engagement.phasevalue : "");
        // if (Engagement.applicationValue !== undefined && Engagement.applicationValue !== null) {
        //   formData2.append(
        //     "ApplicationId",
        //     Engagement.applicationValue.toString()
        //   );
        // } else {
        //   formData2.append(
        //     "ApplicationId", ""
        //   );
        // }
        formData2.append( "ApplicationId", Engagement.applicationValue ? Engagement.applicationValue: "");

        formData2.append("TicketDescription", Description);
        formData2.append(
          "AssignedTo",
          (isAdhoc ? context.EmployeeId : AssignedTo.value).toString()
        );
        formData2.append("Priority", priority.value.toString());
        formData2.append("TicketNatureOfIssue", priority.value.toString());
        formData2.append("HoursAssigned", Number(PlannedHours).toFixed(2));

        formData2.append(
          "IncidentDate",
          moment(incidentDate).format(moment.HTML5_FMT.DATE)
        );
        formData2.append(
          "ReportDate",
          moment(reportedDate).format(moment.HTML5_FMT.DATE)
        );
        formData2.append(
          "StartDate",
          moment(Startbydate).format(moment.HTML5_FMT.DATE)
        );
        formData2.append(
          "ResolveDate",
          moment(Completebydate).format(moment.HTML5_FMT.DATE)
        );

        formData2.append(
          "ResolveDate",
          moment(Completebydate).format(moment.HTML5_FMT.DATE)
        );
        formData2.append(
          "TicketType",
          (type == true ? TicketType.repeated : TicketType.new).toString()
        );
        formData2.append(
          "TicketStatus", TicketStatus.NotStarted.toString()
        );
        formData2.append("IsChargeable", isChargable.toString());
        formData2.append("CreatedBy", context.EmployeeId.toString());
        formData2.append(
          "CreatedDate",
          moment(new Date()).format(moment.HTML5_FMT.DATE)
        );
        formData2.append(
          "NoChargesReason",
          isChargable ? "" : Reason.label || ""
        );
        // formData2.append(
        //   "NoChargesReason",Reason.label 
        // );
        if (ticketsharepointLinkId !== null) {
          formData2.append("TicketSharePointLinkId", ticketsharepointLinkId.toString());
        } else {
          formData2.append("TicketSharePointLinkId", "0"); // or any default value
        }
        formData2.append("IsActive", isActive.toString());
        // if (POFile) {
        //   formData2.append("file", POFile); // Append the file
        // }

        // POFile.forEach(file => {
        //   formData2.append("fileList", file);  // Append each file with the key 'file'
        // });
        if (files) {
          Array.from(files).forEach((file, index) => {
            formData2.append("FileList", file); // Append each individual file
          });
        }


        //Ended by yogesh

        if (isAdhoc) {

          if (isEngagementLead === false && !RoleId.includes("3") && !RoleId.includes("8")) {
            notify(1, "You're not allowed to create a Ticket for this Engagement.");
          } else {
            await showLoader();
            await submitApiCall(formData2);
          }

        } 
        else {
          await showLoader();
          await submitApiCall(formData2);
        }

      }
    }
    if (action === "reset") {
      setFormErrors({});
      setEngagement({});
      showLoader();
      setFromDate(null);
      setToDate(null);
      setIncidentDate(null);
      setReportedDate(null);
      setTicket("");
      setPrevTicket("");
      setPrevTicketId("");
      setTicketTitle("");
      setDescription("");
      setPlannedHours("");
      setStartbydate(null);
      setCompletebydate(null);
      setAllocatedMandays("");
      setAssignedMandays("");
      setBalancedMandays("");
      setisChargable(false);
      setType(false);
      hideLoader();
    }
    if (action === "Back") {
      //navigate(`${env}/TicketDashboard`);
      navigate(-1);
    }
  };

  const submitApiCall = async (submitObj: any) => {
    const { data } = await APICalls(InsertUpdateTicketData, "POST", submitObj);
   // console.log(data);

    let historyinsertobj = {
      Id: data,
      AssignedTo: context.EmployeeId,
      TicketStatus: TicketStatus.NotStarted,
      TicketNatureOfIssue: priority.value,
      TicketTitle: ticketTitle,
      TicketDescription: Description,
    };
    const { data1 } = await APICall(
      insertTicketHistory,
      "Post",
      historyinsertobj
    );
    if (data && data > 0) {
      navigate(`${env}/TicketDashboard`, { state: "false" });
      notify(0, "Ticket Saved Successfully");
    } else {
      notify(1, "Ticket Creation Failed");
    }
  };

  const assignedToApiCall = async (engagementId: any) => {
    showLoader();
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    let postObject = {
      searchFor: "assignedTo",
      searchValue: engagementId,
      fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
      toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);
    let assignedToArray = [];
    if (data != undefined || data != null) {
      assignedToArray = data.map((assignedTo: any) => ({
        eid: assignedTo.id,
        value: assignedTo.id,
        label: assignedTo.name,
      }));
      assignedToArray.sort((a, b) => a.label.localeCompare(b.label));
      setAssignedToOptions(assignedToArray);
      setDropDown1(true);
      setAssignedToOptionsLoaded(true);
    }
    hideLoader();

    // Return assignedToArray from the function
    return assignedToArray;
  };

  const CommonDropdownFunction = async (searchFor, searchValue, isTicket) => {
    showLoader();
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    let postObject = {
      searchFor: searchFor,
      searchValue: searchValue,
      fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
      toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
      isTicket: isTicket,
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);
    hideLoader();
    return data;
  };

  const engagementApiCall = async () => {
    let EmployeeId = context.EmployeeId; //hardcoded

    var data;
    if (RoleId.includes("3") || RoleId.includes("8")) {
      data = await CommonDropdownFunction(
        "engagementForManagerTicket",
        EmployeeId,
        true
      );
    } else {
      data = await CommonDropdownFunction("engagement", EmployeeId, true);
    }
    //sangam

    if (data != undefined || data != null) {
      let engagementArray = [];

      await data.map((engagement) => {
        let tempObj;
        if (engagement.phase != null) {
          tempObj = {
            phasevalue: engagement.phaseId,
            label: `${engagement.engagement}-${engagement.phase}`,
            value: uuid(),
            engagementId: engagement.engagementId,
            empId: engagement.employeeId,
            engagementType: engagement.engagementType,
          };
        } else if (engagement.application != null) {
          tempObj = {
            applicationValue: engagement.applicationId,
            label: `${engagement.engagement}-${engagement.application}`,
            value: uuid(),
            engagementId: engagement.engagementId,
            empId: engagement.employeeId,
            engagementType: engagement.engagementType,
          };
        } else {
          tempObj = {
            phasevalue: engagement.phaseId,
            label: `${engagement.engagement}`,
            value: uuid(),
            engagementId: engagement.engagementId,
            empId: engagement.employeeId,
            engagementType: engagement.engagementType,
          };
        }
        engagementArray.push(tempObj);
      });

      setEngagementOptions(engagementArray);
    }
    setDropDown1(true);
    // let customerId = 7; //hardcoded
    // let postObject = {
    //   searchFor: "engagement",
    //   searchValue: customerId,
    // };
    // const { data } = await APICall(GetDropDownList, "POST", postObject);
    // if (data != undefined || data != null) {
    //   let engagementArray = [];
    //   await data.map((engagement) => {
    //     let tempObj = {
    //       phasevalue: engagement.phaseId,
    //       label: ` ${engagement.engagement}-${engagement.phase}`,
    //       value: engagement.engagementId,
    //       empId: engagement.employeeId,
    //     };
    //     engagementArray.push(tempObj);
    //   });
    //   setEngagementOptions(engagementArray);
    // }
  };

  const onLoadAPI = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const type = urlParams.get("type");
    if (type == "adhoc") {
      setIsAdHoc(true);
    } else {
      setIsAdHoc(false);
    }
    await engagementApiCall();
  };

  useEffect(() => {
    onLoadAPI();
  }, [location]);

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "Engagement") {
      await setEngagement(event);
      await getBudgetMandays(event.engagementId, event.engagementType);
      await getTotalTimesheetHours(event.engagementId);
      if (event && Object.keys(event).length > 0) {
        await assignedToApiCall(event.engagementId);

        //Reasons Dropdown
        var reason = await CommonDropdownFunction(
          "reason",
          event.engagementType,
          true
        );
        if (reason != undefined || reason != null) {
          let tempArray = [];
          await reason.map((reasons) => {
            let tempObj = {
              value: reasons.id,
              label: reasons.reason,
            };
            tempArray.push(tempObj);
          });
          setReasonOptions(tempArray);
          setDropDown1(true);
        }
        setAssignedTo({});

        //    getCapacityEngagementByIdApiCall(event.value)
        setFormErrors((preState) => ({
          ...preState,
          ["Engagement_isEmpty"]: undefined,
        }));
        formErrorObj["Engagement_isEmpty"] = undefined;
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["Engagement_isEmpty"]: "Engagement can not be empty",
        }));
        formErrorObj["Engagement_isEmpty"] = "Engagement can not be empty";
      }
    }
    if (apiFieldName === "AssignedTo" && !isAdhoc) {
      setAssignedTo(event);
      if (event && Object.keys(event).length > 0) {
        //assignedToApiCall(event.value);
        setFormErrors((preState) => ({
          ...preState,
          ["AssignedTo_isEmpty"]: undefined,
        }));
        formErrorObj["AssignedTo_isEmpty"] = undefined;
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["AssignedTo_isEmpty"]: "Assigned to can not be empty",
        }));
        formErrorObj["AssignedTo_isEmpty"] = "Assigned to can not be empty";
      }
    }
    if (apiFieldName === "Reason") {
      setReason(event);
      if (event && Object.keys(event).length > 0) {
        // assignedToApiCall(event.value);
        setFormErrors((preState) => ({
          ...preState,
          ["Reason_isEmpty"]: undefined,
        }));
        formErrorObj["Reason_isEmpty"] = undefined;
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["Reason_isEmpty"]: "Reason can not be empty",
        }));
        formErrorObj["Reason_isEmpty"] = "Reason can not be empty";
      }
    }
    if (apiFieldName === "priority") {
      setPriority(event);
      if (event && Object.keys(event).length > 0) {
        // assignedToApiCall(event.value);
        setFormErrors((preState) => ({
          ...preState,
          ["priority_isEmpty"]: undefined,
        }));
        formErrorObj["priority_isEmpty"] = undefined;
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["priority_isEmpty"]: "Priority can not be empty",
        }));
        formErrorObj["priority_isEmpty"] = "Priority can not be empty";
      }
    }
  };

  useEffect(() => {
    setPriority(priorityOptions[2]);
  }, []);

  const handleIsActiveChange = () => {
    setIsActive(!isActive);
  };
  return (
    <>
      <Heading title={"Ticket Assignment"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement / Application / Phase <sup>*</sup>
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select"
                // isDisabled={false}
                isDisabled={EditId ? true : false}
                value={Engagement}
                onChange={(event) => selectOnChange(event, "Engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["Engagement_isEmpty"]}</p>
            </div>
          </div>
          {!isAdhoc ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>From date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="From date"
                      value={fromDate}
                      onChange={(e) => handleTextEvent(e, "fromDate")}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                  </LocalizationProvider>
                  <p style={{ color: "red" }}>
                    {formErrors["fromDate_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>To date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="To date"
                      value={toDate}
                      onChange={(e) => handleTextEvent(e, "toDate")}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                  </LocalizationProvider>
                  <p style={{ color: "red" }}>{formErrors["toDate_isEmpty"]}</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Allocated Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={allocatedMandays}
                    onChange={(e) => handleTextEvent(e, "allocatedMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["allocatedMandays_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Assigned Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={assignedMandays}
                    onChange={(e) => handleTextEvent(e, "assignedMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["assignedMandays_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Balance Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={balancedMandays}
                    onChange={(e) => handleTextEvent(e, "balancedMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["balancedMandays_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          ) : null}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Budget Man-days / M</label>
              <InputForm
                placeholder={""}
                isDisabled={true}
                textArea={false}
                className="numRight"
                value={budgetMandaysPerMonth}
                onChange={(e) => handleTextEvent(e, "budget_man_days")}
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Total Hours </label>
              <InputForm
                placeholder={""}
                isDisabled={true}
                textArea={false}
                value={totalTimesheetHours}
                onChange={(e) => handleTextEvent(e, "balancedMandays")}
                className="numRight"
              //type="number"
              />
            </div>
          </div>
          {/* Omkar P */}
          {/* isActive */}
          {EditId && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="dropdown25">Is Active</label>
                <div>
                  <input
                    type="checkbox"
                    id="dropdown25"
                    checked={isActive}
                    onChange={handleIsActiveChange}
                    disabled={EditId ? false : true}
                  />
                </div>
              </div>
            </div>
          )}
          {/* Omkar P */}
          {!isAdhoc ? <div></div> : null}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group clearfix">
              <label>Is Chargeable</label>
              <div>
                <label style={{ float: "left", marginRight: "5px" }}>No</label>
                <Form style={{ float: "left" }}>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label=""
                    onChange={(e) =>
                      handleCheckEvent(e.target.checked, "isChargable")
                    }
                    checked={isChargable}
                  />
                </Form>
                <label style={{ float: "left" }}>Yes</label>
              </div>
            </div>
          </div>
          {isChargable === false ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Reason, if not chargeable <sup>*</sup>
                  </label>
                  <SelectForm
                    key={1}
                    options={ReasonOptions}
                    placeholder="Select"
                    isDisabled={false}
                    value={Reason}
                    onChange={(event) => selectOnChange(event, "Reason")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <p style={{ color: "red" }}>{formErrors["Reason_isEmpty"]}</p>
                </div>
              </div>
            </>
          ) : null}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Priority</label>
              <SelectForm
                key={1}
                options={priorityOptions}
                placeholder="Select"
                isDisabled={false}
                value={priority}
                onChange={(event) => selectOnChange(event, "priority")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["priority_isEmpty"]}</p>
            </div>
          </div>
          {!isAdhoc ? (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Assigned To <sup>*</sup>
                </label>
                <SelectForm
                  key={1}
                  options={assignedToOptions}
                  placeholder="Select"
                  isDisabled={false}
                  value={AssignedTo}
                  onChange={(event) => selectOnChange(event, "AssignedTo")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
                <p style={{ color: "red" }}>
                  {formErrors["AssignedTo_isEmpty"]}
                </p>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Planned Hours <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={PlannedHours}
                onChange={(e) => handleTextEvent(e, "PlannedHours")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <p style={{ color: "red" }}>
                {formErrors["PlannedHours_isEmpty"]}
              </p>
            </div>
          </div>
          {/* Ticket Title */}
          <div className="col-lg-12 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Ticket Title <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={true}
                value={ticketTitle}
                rows={2}
                onChange={(e) => handleTextEvent(e, "ticketTitle")}
              />
              <p style={{ color: "red" }}>
                {formErrors["ticketTitle_isEmpty"]}
              </p>
            </div>
          </div>
          {/* Ticket Description */}
          <div className="col-lg-12 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Ticket Description <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={true}
                value={Description}
                rows={5}
                onChange={(e) => handleTextEvent(e, "Description")}
              />
              <p style={{ color: "red" }}>
                {formErrors["Description_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Incident date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Incident date"
                  value={incidentDate}
                  onChange={(e) => handleTextEvent(e, "incidentDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["incidentDate_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Reported date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Reported date"
                  value={reportedDate}
                  onChange={(e) => handleTextEvent(e, "reportedDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  minDate={incidentDate}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["reportedDate_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Start by date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Start by date"
                  value={Startbydate}
                  onChange={(e) => handleTextEvent(e, "Startbydate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  minDate={reportedDate}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["Startbydate_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Resolve by date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Resolve by date"
                  value={Completebydate}
                  onChange={(e) => handleTextEvent(e, "Completebydate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  minDate={Startbydate}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["Completebydate_isEmpty"]}
              </p>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>Type</label>
                <br />
                <label style={{ float: "left" }}>First Time</label>
                <Form style={{ float: "left" }}>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label=""
                    onChange={(e) => handleCheckEvent(e.target.checked, "type")}
                  />
                </Form>
                <label style={{ float: "left" }}>Repeat</label>
              </div>
            </div> */}
          {/* added by yogesh */}
          <div className="row">
            {!EditId &&  (
              <>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Attachments <sup></sup>
                    </label>
                    <div className="input-group">
                      <div className="custom-file">
                        
                          <input
                            multiple
                            type="file"
                            accept=".pdf, .doc, .docx, .png, .jpg, .jpeg, .xlsx, .pptx, .eml"
                            className="custom-file-input"
                            id="file"
                            aria-describedby="inputGroupFileAddon01"
                            style={{ borderRadius: "2px" }}
                            onChange={(e) => {
                              handleFiles(e, "PO Upload"); // Call handleFiles to process the files
                            }}
                          />
                        
                        <label className="custom-file-label" htmlFor="file">
                          {FileNames || "Choose file..."}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group mt-4">
                    <button
                      className="btn btn-secondary"
                      style={{ marginLeft: 5, marginTop: 10 }}
                      onClick={handleClear}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </>
            ) }
          </div>

          {/* ended by */}
          {type === true ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group">
                  <label>Previous Ticket ID, If Repeat</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={false}
                    textArea={false}
                    value={prevTicketId}
                    onChange={(e) => handleTextEvent(e, "prevTicketId")}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["prevTicketId_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-8 col-md-8 col-sm-12">
                <div className="form-group">
                  <label>Previous Ticket</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={true}
                    value={prevTicket}
                    onChange={(e) => handleTextEvent(e, "prevTicket")}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["prevTicket_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex gap-2 justify-content-between">
              <div>
                <button
                  className="btn btn-reset"
                  onClick={(e) => onClickFunction("Back")}
                >
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => onClickFunction("reset")}
                  className="btn btn-reset"
                >
                  Reset
                </button>
                <button
                  onClick={() => onClickFunction("submit")}
                  className="btn btn-submit"
                  disabled={disabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TicketAssignment;